import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import classnames from 'classnames';
import { Icon, Text } from "../../../";
import styles from './Checkbox.scss';
/**
 * @todo Checkbox with button styles
 * @todo Add `indeterminate` state
 * @todo Checkbox group (`min`/`max` number of checkbox checked)
 */

/**
 * Props
 */

var Checkbox = function Checkbox(_ref) {
  var _classnames;

  var children = _ref.children,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 'on' : _ref$value,
      name = _ref.name,
      className = _ref.className,
      isChecked = _ref.isChecked,
      isReadonly = _ref.isReadonly,
      isDisabled = _ref.isDisabled,
      onChange = _ref.onChange,
      errorMessage = _ref.errorMessage;

  var _useState = useState(!!isChecked),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var handleChange = function handleChange(e) {
    if (!isDisabled && !isReadonly) {
      setChecked(function (prevState) {
        return !prevState;
      });
      if (onChange) onChange(e);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.wrapper, className)
  }, /*#__PURE__*/React.createElement("label", {
    className: classnames(styles.checkboxWrap, (_classnames = {}, _defineProperty(_classnames, styles.disabled, isDisabled), _defineProperty(_classnames, styles.readonly, isReadonly), _classnames))
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.checkboxControl
  }, /*#__PURE__*/React.createElement("input", {
    name: name,
    type: "checkbox",
    value: value,
    checked: checked,
    readOnly: isReadonly,
    disabled: isDisabled,
    onChange: handleChange,
    className: styles.checkboxInput
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.checkboxBox, _defineProperty({}, styles.checkboxBox_error, !!errorMessage))
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "checkbox-check",
    size: "medium",
    color: "background",
    className: styles.checkboxIcon
  }))), children && /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, children)), !!errorMessage && /*#__PURE__*/React.createElement(Text, {
    tag: "div",
    color: "fail",
    className: styles.errorMessage
  }, errorMessage));
};

export default Checkbox;